module.exports = __webpack_public_path__ + "static/media/donate_icon.944e1573.svg";